import { render, staticRenderFns } from "./ResponsiveBottomNavigation.vue?vue&type=template&id=0c6a7d7a&lang=html&"
import script from "./ResponsiveBottomNavigation.vue?vue&type=script&lang=js&"
export * from "./ResponsiveBottomNavigation.vue?vue&type=script&lang=js&"
import style0 from "./ResponsiveBottomNavigation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports